import React, { useState } from 'react';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import PopperPortal from '../PopperPortal';
import { setRefs } from '../../../utils/refHelpers';
import { useBasePopper } from '../hooks/useBasePopper';
const PopperPositionedPopover = /*#__PURE__*/ React.forwardRef(({ offsetModifier, allowFlip, disablePlacementModifier, className, portalClassName, placement, secondaryPlacement, positionFixed, eventsEnabled, referenceElement: referenceProp, usePortal, children, isVisible = true, onReferenceClick, onReferenceMouseEnter, onReferenceMouseLeave, renderPopover, renderReference }, innerRef)=>{
    const [referenceElement, setReferenceElement] = useState(null);
    const positioningProps = useBasePopper({
        placement,
        secondaryPlacement,
        eventsEnabled,
        positionFixed,
        offsetModifier,
        allowFlip,
        disablePlacementModifier,
        referenceElement: referenceProp !== null && referenceProp !== void 0 ? referenceProp : referenceElement
    });
    useDebugRerenders('PopperPositionedPopover', {
        offsetModifier,
        allowFlip,
        disablePlacementModifier,
        className,
        portalClassName,
        placement,
        secondaryPlacement,
        positionFixed,
        eventsEnabled,
        referenceElement,
        referenceProp,
        usePortal,
        children,
        isVisible,
        onReferenceClick,
        onReferenceMouseEnter,
        onReferenceMouseLeave,
        renderPopover,
        renderReference
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !referenceProp && renderReference && /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: innerRef,
        onClick: onReferenceClick,
        onMouseEnter: onReferenceMouseEnter,
        onMouseLeave: onReferenceMouseLeave
    }, renderReference({
        ref: setReferenceElement
    })), !referenceProp && !renderReference && /*#__PURE__*/ React.createElement("div", {
        className: className,
        ref: (node)=>setRefs([
                setReferenceElement,
                innerRef
            ], node),
        onClick: onReferenceClick,
        onMouseEnter: onReferenceMouseEnter,
        onMouseLeave: onReferenceMouseLeave
    }, children), isVisible && (usePortal ? /*#__PURE__*/ React.createElement(PopperPortal, {
        portalClassName: portalClassName
    }, renderPopover(positioningProps)) : renderPopover(positioningProps)));
});
PopperPositionedPopover.displayName = 'PopperPositionedPopover';
export default PopperPositionedPopover;

//# sourceMappingURL=PopperPositionedPopover.js.map